module.exports = __webpack_public_path__ + "img/3.4c3366d6.jpeg";